<template>
  <Layout>
    <PageHeader :title="page_title" :items="items"/>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <Loader :loading="httpSend">
            <div class="card-body">
              <form-wizard ref="tabPessoa"
                           next-button-text="Próximo"
                           back-button-text="Anterior"
                           color="#556ee6">
                <tab-content :before-change="validaTabPessoais" title="Dados Pessoais" icon="bx bx-user">
                  <div class="row">
                    <div class="col-12">
                      <b-form>
                        <div class="row">
                          <div class="col-md-3">
                            <b-form-group label="CPF" label-for="pes_cpfcnpj">
                              <h5 class="mb-3">{{ pessoa.tps_cpf_cnpj | VMask('###.###.###-##') }}</h5>
                            </b-form-group>
                          </div>
                          <div class="col-md-6">
                            <b-form-group label="Nome Completo" label-for="tps_razao_social_nome">
                              <input class="form-control" v-model="pessoa.tps_razao_social_nome"
                                     :class="{ 'is-invalid': $v.pessoa.tps_razao_social_nome.$error }"
                                     id="tps_razao_social_nome" type="text">
                              <div v-if="$v.pessoa.tps_razao_social_nome.$error" class="invalid-feedback">
                                Informe seu nome completo
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Data de Nascimento" label-for="tps_data_abertura_nascimento">
                              <input v-model="pessoa.tps_data_abertura_nascimento" id="tps_data_abertura_nascimento"
                                     :class="{ 'is-invalid': $v.pessoa.tps_data_abertura_nascimento.$error }"
                                     type="date" class="form-control"/>
                              <div v-if="$v.pessoa.tps_data_abertura_nascimento.$error" class="invalid-feedback">
                                Informe a data
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <b-form-group label="Núm. RG" label-for="tps_rg">
                              <input class="form-control"
                                     :class="{ 'is-invalid': $v.pessoa.tps_rg.$error }"
                                     v-model="pessoa.tps_rg" id="tps_rg" type="text">
                              <div v-if="$v.pessoa.tps_rg.$error" class="invalid-feedback">
                                Informe número do RG
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Órgão emissor RG" label-for="tps_orgaoemissor">
                              <input class="form-control"
                                     :class="{ 'is-invalid': $v.pessoa.tps_orgaoemissor.$error }"
                                     v-model="pessoa.tps_orgaoemissor" id="tps_orgaoemissor"
                                     type="text">
                              <div v-if="$v.pessoa.tps_orgaoemissor.$error" class="invalid-feedback">
                                Informe o Órgão emissor
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-6">
                            <b-form-group label="Natureza Jurídica" label-for="tps_natureza_juridica">
                              <select id="tps_natureza_juridica" :class="{ 'is-invalid': $v.pessoa.tps_natureza_juridica.$error }" v-model="pessoa.tps_natureza_juridica" class="custom-select">
                                <option value=""></option>
                                <option v-for="t in tab_selecoes.natureza_juridica" v-bind:value="t.naj_codigo" v-bind:key="t.naj_codigo">
                                  [{{t.naj_referencia}}] {{ t.naj_descricao }}
                                </option>
                              </select>
                              <div v-if="$v.pessoa.tps_natureza_juridica.$error" class="invalid-feedback">
                                Informe a natureza jurídica
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <b-form-group label="Sexo" label-for="tps_sexo">
                              <select id="tps_sexo" v-model="pessoa.tps_sexo" class="custom-select"
                                      :class="{ 'is-invalid': $v.pessoa.tps_sexo.$error }"
                              >
                                <option value=""></option>
                                <option v-for="t in tab_selecoes.sexo" v-bind:value="t.tab_codigo"
                                        v-bind:key="t.tab_codigo">
                                  {{ t.tab_nome }}
                                </option>
                              </select>
                              <div v-if="$v.pessoa.tps_sexo.$error" class="invalid-feedback">
                                Informe o sexo
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="PIS/PASEP" label-for="tps_pispasep">
                              <input v-model="pessoa.tps_pispasep" v-mask="'###.#####.##.#'" id="tps_pispasep"
                                     type="text"
                                     class="form-control"/>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Título eleitoral" label-for="tps_tituloeleitor">
                              <input v-model="pessoa.tps_tituloeleitor" class="form-control" id="tps_tituloeleitor"
                                     v-mask="'####.####.####'" type="text">
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Estado Civil" label-for="tps_estadocivil">
                              <select id="tps_estadocivil" v-model="pessoa.tps_estadocivil" class="custom-select"
                                      >
                                <option value=""></option>
                                <option v-for="t in tab_selecoes.estado_civil" v-bind:value="t.tab_codigo"
                                        v-bind:key="t.tab_codigo">
                                  {{ t.tab_nome }}
                                </option>
                              </select>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <b-form-group label="Nível de Escolaridade" label-for="tps_escolaridade">
                              <select id="tps_escolaridade" v-model="pessoa.tps_escolaridade" class="custom-select"
                              >
                                <option value=""></option>
                                <option v-for="t in tab_selecoes.escolaridade" v-bind:value="t.tab_codigo"
                                        v-bind:key="t.tab_codigo">
                                  {{ t.tab_nome }}
                                </option>
                              </select>
                            </b-form-group>
                          </div>
                          <div class="col-md-5">
                            <b-form-group label="Classe Profissional" label-for="tps_sociedade_classe">
                              <select id="tps_sociedade_classe" v-model="pessoa.tps_sociedade_classe"
                                      class="custom-select">
                                <option value=""></option>
                                <option v-for="t in tab_selecoes.classe_profissional" v-bind:value="t.tab_codigo"
                                        v-bind:key="t.tab_codigo">
                                  {{ t.tab_nome }}
                                </option>
                              </select>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Núm. Reg de Classe" label-for="tps_numero_registro_classe">
                              <input class="form-control" v-model="pessoa.tps_numero_registro_classe"
                                     id="tps_numero_registro_classe" type="text">
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <b-form-group label="Início das atividades no município" label-for="tps_data_inicio">
                              <input v-model="pessoa.tps_data_inicio" id="tps_data_inicio"
                                     :class="{ 'is-invalid': $v.pessoa.tps_data_inicio.$error }"
                                     type="date" class="form-control"/>
                              <div v-if="$v.pessoa.tps_data_inicio.$error" class="invalid-feedback">
                                Informe a data
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                      </b-form>
                    </div>
                  </div>
                </tab-content>
                <tab-content :before-change="validaTabContato" :lazy="true" title="Contato" icon="bx bx-phone-call">
                  <ContatoSolicitacoes
                      :telefone_tipo="tab_selecoes.telefone_tipo"
                      :list_email="lista_email"
                      :list_telefone="lista_telefone">
                  </ContatoSolicitacoes>
                </tab-content>
                <tab-content :before-change="validaTabEndereco" :lazy="true" title="Endereço" icon="bx bx-envelope">
                  <EnderecoSolicitacoes
                      :pessoa="pessoa"
                      :endereco_tipo="tab_selecoes.endereco_tipo"
                      :list_endereco="lista_endereco">
                  </EnderecoSolicitacoes>
                </tab-content>
                <tab-content :before-change="validaTabFiscal" :lazy="true" title="Dados Fiscais"
                             icon="bx bx-book-bookmark">
                  <FiscalFisicoSolicitacoes
                      :list_servicos="list_servicos"
                      :up_contador="contador">
                  </FiscalFisicoSolicitacoes>
                </tab-content>
                <tab-content title="Confirmação" :lazy="true" icon="bx bx-check-double">
                  <ConfirmacaoSolicitacoes>
                  </ConfirmacaoSolicitacoes>
                </tab-content>
                <template slot="footer" scope="props">
                  <div class=wizard-footer-left>
                    <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab()"
                                   :style="props.fillButtonStyle"><i class="fas fa-arrow-left"></i> Anterior
                    </wizard-button>
                  </div>
                  <div class="wizard-footer-right">
                    <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right"
                                   :style="props.fillButtonStyle">Próximo <i class="fas fa-arrow-right"></i>
                    </wizard-button>
                    <button v-if="props.isLastStep && !pessoa.tem_solicitacao" type="button"
                            @click="confirmacao(1)"
                            class="wizard-footer-right btn btn-label btn-success"><i
                        class="bx bx-check-double label-icon"></i>
                      Enviar Solicitação
                    </button>
                    <button v-if="props.isLastStep && !pessoa.tem_solicitacao" type="button"
                            @click="confirmacao('R')"
                            class="wizard-footer-right finish-button btn btn-label btn-light mr-3">
                      <i class="bx bx-save label-icon"></i>
                      Salvar em Rascunho
                    </button>
                  </div>
                </template>
              </form-wizard>
            </div>
          </Loader>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {FormWizard, TabContent, WizardButton} from "vue-form-wizard";
import {getTabSelecoes} from "@/api/geral/helps";
import {required} from "vuelidate/lib/validators";
import {
  getSolicitacao,
  setCecPessoaFisica,
  setCecContato,
  setCecEndereco,
  setCecServico,
  setCecConfirmacao
} from "@/api/solicitacao/pessoa"
import ContatoSolicitacoes from "@/router/views/contribuinte/components/contato-solicitacoes"
import EnderecoSolicitacoes from "@/router/views/contribuinte/components/endereco-solicitacoes"
import FiscalFisicoSolicitacoes from "@/router/views/contribuinte/components/fiscal-fisico-solicitacoes"
import ConfirmacaoSolicitacoes from "@/router/views/contribuinte/components/confirmacao-solicitacoes"
import {geraHashObjeto, geraHashObjetoIgual} from "@/helps/util";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Pessoa Física",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Loader,
    PageHeader,
    FormWizard,
    TabContent,
    WizardButton,
    ContatoSolicitacoes,
    EnderecoSolicitacoes,
    FiscalFisicoSolicitacoes,
    ConfirmacaoSolicitacoes
  },
  props: {
    page_title: {
      type: String,
      required: true,
    },
    tps_tipo: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      title: "Solicitação - Pessoa Física",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Solicitação',
          href: '/contribuinte/solicitacao',
        },
        {
          text: 'Pessoa Física',
          active: true,
        },
      ],
      httpSend: false,
      temSocio: false,
      pessoa: {
        tps_codigo: null,
        tps_cpf_cnpj: "",
        tps_razao_social_nome: "",
        tps_data_abertura_nascimento: null,
        tps_data_inicio: null,
        tps_sexo: "",
        tps_rg: "",
        tps_orgaoemissor: "",
        tps_pispasep: "",
        tps_estadocivil: "",
        tps_tituloeleitor: "",
        tps_escolaridade: "",
        tps_sociedade_classe: "",
        tps_numero_registro_classe: "",
        tps_natureza_juridica: null,
        tps_tributacao: "6",
        tps_tipo: null,
        tem_solicitacao: false
      },
      tab_selecoes: {
        natureza_juridica: [],
        classe_profissional: [],
        escolaridade: [],
        estado_civil: [],
        nacionalidade: [],
        sexo: [],
        telefone_tipo: [],
        endereco_tipo: []
      },
      lista_email: [],
      lista_telefone: [],
      lista_endereco: [],
      list_servicos: [],
      contador: {},
      economico: {
        tec_codigo: null,
        tec_contador: null,
        tec_contador_proprio: null,
        tec_protocolo: null,
        tec_tabeliao: null,
        tps_codigo: null
      },
      hashPessoa: "",
      hashContato: "",
      hashEndereco: ""
    };
  },
  validations: {
    pessoa: {
      tps_razao_social_nome: {
        required,
      },
      tps_data_abertura_nascimento: {
        required,
      },
      tps_data_inicio: {
        required,
      },
      tps_sexo: {
        required,
      },
      tps_rg: {
        required,
      },
      tps_orgaoemissor: {
        required,
      },
      tps_natureza_juridica: {
        required,
      },
    }
  },
  created() {
    this.tabSelecoes();
    this.user = this.$store.state.auth.currentUser;
    this.pessoa.tps_cpf_cnpj = this.user.pes_cpfcnpj
    this.pessoa.tps_razao_social_nome = this.user.pes_nome;
    if (this.$route.params.tps_hash) {
      this.getSocilitacao();
    } else {
      this.pessoa.tps_tipo = this.tps_tipo;
    }
  },
  methods: {
    tabSelecoes() {
      getTabSelecoes(1).then(response => {
        this.tab_selecoes.natureza_juridica = response.dados.natureza_juridica;
        this.tab_selecoes.classe_profissional = response.dados.classe_profissional;
        this.tab_selecoes.escolaridade = response.dados.escolaridade;
        this.tab_selecoes.estado_civil = response.dados.estado_civil;
        this.tab_selecoes.nacionalidade = response.dados.nacionalidade;
        this.tab_selecoes.sexo = response.dados.sexo;
        this.tab_selecoes.endereco_tipo = response.dados.endereco_tipo;
        this.tab_selecoes.telefone_tipo = response.dados.telefone_tipo;
      }).catch(error => {
        console.log(error);
      })
    },
    getSocilitacao() {
      this.httpSend = true;
      getSolicitacao(this.$route.params.tps_hash).then(response => {
        if (response.status) {
          this.pessoa = response.dados.pessoa;
          if(this.pessoa.tps_natureza_juridica){
            if(this.pessoa.tps_natureza_juridica.naj_codigo){
              this.pessoa.tps_natureza_juridica = this.pessoa.tps_natureza_juridica.naj_codigo;
            }
          }
          this.pessoa.tps_tipo = parseInt(this.pessoa.tps_tipo);
          this.hashPessoa = geraHashObjeto(this.pessoa);
          this.lista_email = response.dados.emails;
          this.lista_telefone = response.dados.telefones;
          this.hashContato = geraHashObjeto({lista_email: this.lista_email, lista_telefone: this.lista_telefone});
          this.lista_endereco = response.dados.enderecos;
          this.hashEndereco = geraHashObjeto(this.lista_endereco);
          this.economico = response.dados.economico;
          if (this.economico) {
            this.contador = {
              pes_codigo: this.economico.tec_contador,
              proprio_contador: (this.economico.tec_contador_proprio && this.economico.tec_contador_proprio === 'S'),
              pes_nome: (this.economico.contador && this.economico.contador.pes_nome) ? this.economico.contador.pes_nome : null,
              pes_crc: (this.economico.contador && this.economico.contador.pes_crc) ? this.economico.contador.pes_crc : null,
            }
          }
          this.list_servicos = response.dados.servicos;
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    validaTabPessoais: function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      if (this.pessoa.tem_solicitacao) {
        return true;
      }
      if (geraHashObjetoIgual(this.pessoa, this.hashPessoa)) {
        return true;
      }
      return new Promise((resolve) => {
        this.httpSend = true;
        setCecPessoaFisica(this.pessoa).then(response => {
          if (response.status) {
            this.pessoa = response.dados;
            this.hashPessoa = geraHashObjeto(this.pessoa);
            resolve(true)
          } else {
            this.$toast.error(response.mensagem);
            resolve(false)
          }
        }).catch(error => {
          this.$toast.error(error);
          resolve(false)
        }).finally(() => {
          this.httpSend = false
        })
      })
    },
    validaTabContato: function () {
      if (this.lista_email.length > 0 && this.lista_telefone.length > 0) {
        if (this.pessoa.tem_solicitacao) {
          return true;
        }
        if (geraHashObjetoIgual({
          lista_email: this.lista_email,
          lista_telefone: this.lista_telefone
        }, this.hashContato)) {
          return true;
        }
        return new Promise((resolve) => {
          this.httpSend = true;
          setCecContato({
            pessoa: this.pessoa,
            email: this.lista_email,
            telefone: this.lista_telefone
          }).then(response => {
            if (response.status) {
              this.lista_email = response.dados.emails;
              this.lista_telefone = response.dados.telefones;
              this.hashContato = geraHashObjeto({lista_email: this.lista_email, lista_telefone: this.lista_telefone});
              resolve(true)
            } else {
              this.$toast.error(response.mensagem);
              resolve(false)
            }
          }).catch(error => {
            this.$toast.error(error);
            resolve(false)
          }).finally(() => {
            this.httpSend = false
          })
        })
      } else {
        return false
      }
    },
    validaTabEndereco: function () {
      if (this.lista_endereco.length > 0 && this.lista_endereco.length > 0) {
        if (this.pessoa.tem_solicitacao) {
          return true;
        }
        if (geraHashObjetoIgual(this.lista_endereco, this.hashEndereco)) {
          return true;
        }
        return new Promise((resolve) => {
          this.httpSend = true;
          setCecEndereco({
            pessoa: this.pessoa,
            endereco: this.lista_endereco
          }).then(response => {
            if (response.status) {
              this.lista_endereco = response.dados;
              this.hashEndereco = geraHashObjeto(this.lista_endereco);
              resolve(true)
            } else {
              this.$toast.error(response.mensagem);
              resolve(false)
            }
          }).catch(error => {
            this.$toast.error(error);
            resolve(false)
          }).finally(() => {
            this.httpSend = false
          })
        })
      } else {
        return false
      }
    },
    validaTabFiscal: function () {
      if (this.pessoa.tem_solicitacao) {
        return true;
      }
      if (this.list_servicos.length > 0) {
        return new Promise((resolve) => {
          this.httpSend = true;
          setCecServico({
            pessoa: this.pessoa,
            economico: this.economico,
            servicos: this.list_servicos,
            contador: this.contador
          }).then(response => {
            if (response.status) {
              this.economico = response.dados.economico;
              this.list_servicos = response.dados.servicos;
              resolve(true)
            } else {
              this.$toast.error(response.mensagem);
              resolve(false)
            }
          }).catch(error => {
            this.$toast.error(error);
            resolve(false)
          }).finally(() => {
            this.httpSend = false
          })
        })
      } else {
        return false
      }
    },
    isLastStep() {
      if (this.$refs.tabPessoa) {
        return this.$refs.tabPessoa.isLastStep
      }
      return false
    },
    confirmacao: function (chm_status) {
      if (chm_status === 'R') {
        this.enviaSolicitacao(chm_status);
      } else {
        Swal.fire({
          title: "Enviar solicitação?",
          text: "",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#100e0e",
          confirmButtonText: "Sim",
          cancelButtonText: "Não"
        }).then(result => {
          if (result.isConfirmed) {
            this.enviaSolicitacao(chm_status);
          } else {
            return chm_status;
          }
        });
      }
    },
    enviaSolicitacao(chm_status) {
      this.httpSend = true;
      setCecConfirmacao({
        pessoa: this.pessoa,
        situacao: {chm_status: chm_status},
      }).then(response => {
        if (response.status) {
          this.$toast.success(response.mensagem)
          this.$router.push({name: 'contribuinte-solicitacao'})
        } else {
          this.$toast.error(response.mensagem);
        }
      }).catch(error => {
        this.$toast.error(error);
      }).finally(() => {
        this.httpSend = false
      })
    }
  }
};
</script>


